<template>
  <NewTask
    taskType="bank_statement"
    :docList="['Bank Statement']"
    :textInput="textInput"
    :beforeCreate="processTextInput"
  >
  </NewTask>
</template>

<script>
import axios from 'axios'
import NewTask from '@/components/NewTask.vue';

export default {
  components: {
    NewTask
  },
  data() {
    return {
      clientList: ['Client List 1', 'Client List 2', 'Client List 3', 'Client List 4', 'Client List 5'],
      supplierList: ['Supplier List 1', 'Supplier List 2', 'Supplier List 3', 'Supplier List 4', 'Supplier List 5'],
    }
  },
  computed: {
    textInput() {
      return this.clientList.concat(this.supplierList)
    }
  },
  methods: {
    toJsonKey(value) {
      return value.replace(" ", "_").toLowerCase()
    },
    processTextInput(input) {
      let returnList = []
      for (const list of [this.clientList, this.supplierList]) {
        let processedList = []
        for (const entry of list) {
          let fieldName = this.toJsonKey(entry)
          if (input[fieldName]) {
            processedList.push(input[fieldName])
          }
          delete input[fieldName]
        }
        returnList.push(processedList)
      }
      input["text_inputs"] = JSON.stringify({ client_list: returnList[0], supplier_list: returnList[1] })
      return input
    }
  }
}
</script>
